(function (ng) {
    

    angular.module('module', []);
})(window.angular);
